import { useState } from 'react'
import { BrowserRouter as Router, Route } from 'react-router-dom'
import Header from "./components/Header"
import Footer from "./components/Footer"
import About from "./components/About"
import Tasks from "./components/Tasks"
import AddTask from "./components/AddTask"

function App() {
  const [showAddTask, setShowAddTask] = useState(false)
  const [tasks, setTasks] = useState([
    {
      "text": "Cook jellof rice",
      "day": "Today",
      "reminder": true,
      "id": 3
    },
    {
      "text": "Read",
      "day": "Today",
      "reminder": true,
      "id": 4
    }
  ])



//ADD TASK
const addTask = (task) => {

  const id = Math.floor(Math.random() * 9000) + 1
  const newTask = { id, ...task }
  setTasks([...tasks, newTask]);
}

//DELETE TASK
const deleteTask = (id) => {
 
  setTasks(tasks.filter((task) => task.id !== id))
}

//TOGGLE REMINDER
const toggleReminder = (id) => {
  setTasks(tasks.map((task) => task.id === id ? { ...task, reminder: task.reminder } : task));
}

  return (
  <Router>
    <div className="container">
      <Header onAddd={() => setShowAddTask(!showAddTask)} showAdd={showAddTask}/>
      
      <Route path='/' exact render={(props) => (
        <>
          {showAddTask && <AddTask onAdd={addTask}/>}
          {tasks.length > 0 ? <Tasks tasks={tasks} onDelete={deleteTask} onToggle={toggleReminder}/> : "No available tasks.. "}
        </>
      )}/>
      <Route path="/about" component={About} />
      <Footer />

    </div>
  </Router>
  );
}

export default App;
